import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import {
  formatDate,
  formatPhone,
  getGenderText,
  getPatientTypeText,
  getLanguageText,
  hasValidContent
} from './utils/appointmentUtils';

const AppointmentInfoEventValue = ({ event }) => {
  const { t } = useLanguage();
  const { value, id } = event;

  const getEventTitle = () => {
    if (event.event_type === 'create') {
      return `📝 ${t('appointmentInfo.submitForm')}`;
    } else if (event.event_type === 'update') {
      return `📋 ${t('appointmentInfo.updateInfo')}`;
    }
    return `📋 ${t('appointmentInfo.appointmentInfo')}`;
  };

  return (
    <div className="space-y-1 text-sm">
      <div className="font-medium text-purple-600">
        {getEventTitle()}
      </div>

      {/* 病人資料 */}
      <div className="space-y-1">
        <div className="font-medium text-gray-700">{t('appointmentInfo.patientData')}:</div>
        {(value?.first_name_en || value?.last_name_en) && (
          <div>👤 {t('appointmentInfo.name')}: {value.first_name_en} {value.last_name_en}</div>
        )}
        {value?.date_of_birth && (
          <div>🎂 {t('appointmentInfo.dateOfBirth')}: {formatDate(value.date_of_birth)}</div>
        )}
        {value?.gender && (
          <div>👫 {t('appointmentInfo.gender')}: {getGenderText(value.gender)}</div>
        )}
        {value?.customer_number && (
          <div>📱 {t('appointmentInfo.phone')}: {formatPhone(value.customer_number)}</div>
        )}
        {(value?.first_name_en || value?.last_name_en) && (
          <div>✉️ {t('appointmentInfo.email')}: {value.email}</div>
        )}
        {value?.language && (
          <div>🌐 {t('appointmentInfo.language')}: {getLanguageText(value.language)}</div>
        )}
        {value?.new_or_follow_up && (
          <div>🏥 {t('appointmentInfo.patientType')}: {getPatientTypeText(value.new_or_follow_up)}</div>
        )}
      </div>

      {/* 預約偏好 */}
      <div className="space-y-1">
        <div className="font-medium text-gray-700">{t('appointmentInfo.preferences')}:</div>
        {value?.preferred_location && (
          <div>📍 {t('appointmentInfo.preferredLocation')}: {value.preferred_location}</div>
        )}
        {value?.preferred_doctor_1 && (
          <div>👨‍⚕️ {t('appointmentInfo.preferredDoctor')}: {value.preferred_doctor_1}</div>
        )}
        {value?.preferred_doctor_2 && (
          <div>👨‍⚕️ {t('appointmentInfo.preferredDoctor2')}: {value.preferred_doctor_2}</div>
        )}
        {value?.preferred_doctor_3 && (
          <div>👨‍⚕️ {t('appointmentInfo.preferredDoctor3')}: {value.preferred_doctor_3}</div>
        )}
        {value?.preferred_date_of_visit_1 && (
          <div>📅 {t('appointmentInfo.preferredDate')}: {formatDate(value.preferred_date_of_visit_1)}</div>
        )}
        {value?.preferred_time_of_visit_1 && (
          <div>🕐 {t('appointmentInfo.preferredTime')}: {value.preferred_time_of_visit_1}</div>
        )}
        {value?.preferred_date_of_visit_2 && (
          <div>📅 {t('appointmentInfo.preferredDate')} (2): {formatDate(value.preferred_date_of_visit_2)}</div>
        )}
        {value?.preferred_time_of_visit_2 && (
          <div>🕐 {t('appointmentInfo.preferredTime')} (2): {value.preferred_time_of_visit_2}</div>
        )}
        {value?.preferred_date_of_visit_3 && (
          <div>📅 {t('appointmentInfo.preferredDate')} (3): {formatDate(value.preferred_date_of_visit_3)}</div>
        )}
        {value?.preferred_time_of_visit_3 && (
          <div>🕐 {t('appointmentInfo.preferredTime')} (3): {value.preferred_time_of_visit_3}</div>
        )}
      </div>

      {/* 額外資訊 */}
      {(hasValidContent(value?.symptoms) || hasValidContent(value?.special_request) || value?.booking_type) && (
        <div className="space-y-1">
          <div className="font-medium text-gray-700">{t('appointmentInfo.additionalInfo')}:</div>
          {hasValidContent(value?.symptoms) && (
            <div>🩺 {t('appointmentInfo.symptoms')}: {value.symptoms}</div>
          )}
          {hasValidContent(value?.special_request) && (
            <div>📝 {t('appointmentInfo.specialRequest')}: {value.special_request}</div>
          )}
          {value?.booking_type && (
            <div>🏥 {t('appointmentInfo.bookingType')}: {value.booking_type}</div>
          )}
        </div>
      )}

      {/* 系統資訊 */}
      {id && (
        <div className="space-y-1">
          <div className="text-xs text-gray-500">{t('appointmentInfo.systemInfo')}:</div>
          <div className="text-xs text-gray-500">📋 {t('appointmentInfo.appointmentInfoId')}: {id}</div>
        </div>
      )}
    </div>
  );
};

export default AppointmentInfoEventValue;
